// removed by extract-text-webpack-plugin
module.exports = {"container":"_2jz2mjA","body":"nUQMpvx","copyright":"_28lMicj","links":"W1vTixy","hideOnSmallViewport":"_2xktXa3"};


//////////////////
// WEBPACK FOOTER
// ./template/components/LegalBar/LegalBar.css
// module id = ./template/components/LegalBar/LegalBar.css
// module chunks = client.sitechrome